{
  "version": 1,
  "asset_id": "c8fb4506-8b42-45ee-9ad8-8e0a1e807013",
  "project_id": "1d7b8e6b-eeef-4a52-9dda-b5fbba0dd955",
  "url": "/__l5e/assets-v1/c8fb4506-8b42-45ee-9ad8-8e0a1e807013/site-specific-window.jpg",
  "r2_key": "a/v1/1d7b8e6b-eeef-4a52-9dda-b5fbba0dd955/c8fb4506-8b42-45ee-9ad8-8e0a1e807013/site-specific-window.jpg",
  "original_filename": "site-specific-window.jpg",
  "size": 183035,
  "content_type": "image/jpeg",
  "created_at": "2026-09-09T15:28:06Z"
}
